module.exports = __webpack_public_path__ + "static/media/m_eyeshape_upturned_darkbrown.30e40495.png";